import { request } from '~/agent';

export const getUnits = params => {
    return request.get(`screening/applications/units`, params);
};
